import { render, staticRenderFns } from "./KeyIndustries.vue?vue&type=template&id=7596e48c&"
import script from "./KeyIndustries.vue?vue&type=script&lang=js&"
export * from "./KeyIndustries.vue?vue&type=script&lang=js&"
import style0 from "./KeyIndustries.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports